import React from "react";

export default function C_V_RANGE({ value, min = 1, max = 100 }) {
  if (value === undefined || value === null || value === "") return null;

  const numValue = Number(value);
  const range = max - min || 1;
  const percentage = Math.max(
    0,
    Math.min(100, ((numValue - min) / range) * 100),
  );

  // Slightly smaller thumb for view mode
  const thumbWidth = 18;
  const thumbOffset = thumbWidth / 2 - (percentage / 100) * thumbWidth;

  return (
    <div
      title={value}
      style={{
        width: "100%",
        height: "100%",
        padding: "0 8px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{
          position: "relative",
          flex: 1,
          height: "18px", // Reduced height
          display: "flex",
          alignItems: "center",
          opacity: 0.8, // Dim the entire component to indicate "view only"
        }}
      >
        {/* Background Track */}
        <div
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            height: "4px",
            backgroundColor: "#e4e4e4", // Lighter gray than edit mode
            borderRadius: "2px",
          }}
        />

        {/* Fill Track */}
        <div
          style={{
            position: "absolute",
            left: 0,
            width: `calc(${percentage}% + ${thumbOffset}px)`,
            height: "4px",
            backgroundColor: "#999", // Muted dark gray instead of black
            borderRadius: "2px",
          }}
        />

        {/* Custom Thumb */}
        <div
          style={{
            position: "absolute",
            left: `calc(${percentage}% + ${thumbOffset}px)`,
            transform: "translateX(-50%)",
            width: `${thumbWidth}px`,
            height: `${thumbWidth}px`,
            borderRadius: "50%",
            backgroundColor: "#999", // Muted thumb color
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "9px",
            fontWeight: "bold",
          }}
        >
          {numValue}
        </div>
      </div>
    </div>
  );
}
